import { useState, useEffect, useRef, useCallback } from 'react';
import './Drawcanvas.css';
import { useDispatch, useSelector } from 'react-redux';
import { initConfigState } from './redux/configState';

function GameConfig(props) {

  const configState = useSelector((state) => state.configState);
  const [cfgState, setCfg] = useState(configState);
  const [ps, setPlayer] = useState(props.ps);
  const [rounds, setRounds] = useState(configState.rounds);
  const [time, setTime] = useState(configState.time);
  const [strokes, setStrokes] = useState(configState.strokes);
  const strokeRef = useRef(null);
  const timeRef = useRef(null);
  const roundsRef = useRef(null);
  const [errMsg, setErrMsg] = useState("");
  const socket = props.socket;
  const dispatch = useDispatch();

  useEffect(() => {
    setCfg(configState);
  }, [configState]);

  useEffect(() => {
    setPlayer(props.ps)
  }, [props.ps]);

  // const handleChange = useCallback((e) => {
  //   e.persist();
  //   let value = e.target.value !== "false";
  //   // might allow for 0 input in the future to mean "unlimited" or something
  //   // if ((isNaN(parseInt(e.target.value)) && e.target.value !== "") || parseInt(e.target.value) < 1 && e.target.value !== "") {
  //   //   return;
  //   // }
  //   if (!isNaN(parseInt(e.target.value)) && e.target.value !== "" && parseInt(e.target.value) > 0) {
  //     setCfg(current => ({ ...current, [e.target.name]: parseInt(e.target.value) }))
  //   }
  //   // not used but just in case we want to add more boolean options in the future
  //   // if (e.target.name !== "censorWord") {
  //   //   value = parseInt(e.target.value);
  //   // }

  // }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    // Convert FormData to a plain JavaScript object
    const formProps = Object.fromEntries(formData);
    // validate inputs
    // TODO:  add some upper limits to prevent crazy inputs
    let errKey = "";
    let error = false;
    formData.forEach((value, key) => {
      if (isNaN(parseInt(value)) || parseInt(value) < 1) {
        errKey = key;
        error = true;
        return;
      }
    });
    if (error) {
      setErrMsg(`Invalid input for ${errKey}`);
      return;
    }
    else {
      setErrMsg("");
      setCfg(current => ({ ...current, ...formProps }));
      dispatch(initConfigState(cfgState));
      socket.emit("updateConfig", (cfgState));
      props.handleClose();
    }
  }, [cfgState, socket, dispatch, props]);

  const closeSettings = useCallback(() => {
    props.handleClose();
  }, [props]);

  return (
    <div className='mx-auto gameConfig'>
      <h3>Game configuration</h3>
      <p className="pb-2 pt-1 m-0 text-red-700">{errMsg}</p>
      <form onSubmit={handleSubmit} className="max-w-md mx-auto pt-2">
        <div className="flex flex-wrap mb-6 max-w-5/6 mx-2">
          <div className="w-full md:max-w-sm px-3 m-auto">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="turoundsrns">
              Number of rounds:
            </label>
            <input name="rounds" defaultValue={cfgState.rounds} ref={roundsRef} inputMode="numeric" disabled={!(ps.host)} 
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="turns" type="text" placeholder={cfgState.turns} />
          </div>
          <div className="w-full md:max-w-sm px-3 m-auto">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="time">
              Time:
            </label>
            <input name="time" defaultValue={cfgState.time} ref={timeRef} inputMode="numeric" disabled={!(ps.host)} 
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="time" type="text" placeholder={cfgState.time} />
          </div>
          <div className="w-full md:max-w-sm px-3 m-auto">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="strokes">
              Number of pen strokes:
            </label>
            <input name="strokes" defaultValue={cfgState.strokes} ref={strokeRef} inputMode="numeric" disabled={!(ps.host)} 
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="strokes" type="text" placeholder={cfgState.strokes}>
            </input>
          </div>
        </div>
        <button disabled={!(ps.host)} type="Submit" className={((!ps.host) ? 'disabled:opacity-50 ' : '') + "m-3 bg-green-500 hover:bg-green-700 font-bold py-2 px-4 rounded"}>Save</button>
        <button onClick={closeSettings} className="m-3 bg-green-500 hover:bg-green-700 font-bold py-2 px-4 rounded">Cancel</button>
      </form>
    </div>
  );
}

export default GameConfig;
